import { z } from 'zod'

export const workforceTypeSchema = z.object({
  name: z.string().min(1, 'Name is required').max(100, 'Name must be at most 100 characters'),
  description: z.string().max(100, 'Description must be at most 100 characters').optional(),
  tenantId: z.number(),
  id: z.number().optional(),
  inUse: z.boolean().optional().default(true),
  validFrom: z.union([z.date(), z.string()]).optional(),
})

export type WorkforceTypeFormData = z.infer<typeof workforceTypeSchema>
